import 'fomantic-ui-less/definitions/behaviors/form';

import 'fomantic-ui-less/definitions/modules/popup.less';
import 'fomantic-ui-less/definitions/modules/popup';
import {handleClick} from '../helper/dom';

export default class RelativeTimeMarkView {
    constructor(mark, view, inline) {
        this.view = view;
        this.inline = inline;
        this.mark = mark;

        this.dom = document.createElement('span');

        if ((mark.attrs.datetime?.startsWith('${') && mark.attrs.datetime?.endsWith('}') || !isNaN(Date.parse(mark.attrs.datetime)))) {
            this.dom.className = 'relative-time';
            this.dom.style.cursor = 'pointer';

            this.dom.setAttribute('datetime', mark.attrs.datetime);

            if (mark.attrs.format) {
                this.dom.setAttribute('format', mark.attrs.format);
            }

            if (mark.attrs.hour && mark.attrs.minute && mark.attrs.second) {
                this.dom.setAttribute('hour', mark.attrs.hour);
                this.dom.setAttribute('minute', mark.attrs.minute);
                this.dom.setAttribute('second', mark.attrs.second);
            }

            this.dom.setAttribute('precision', 'second');
            this.dom.contentEditable = 'false';
        }

        this.dom.addEventListener('click', e => handleClick(view, this.dom, view.state.schema.marks.relative_time));
    }
}